module.exports = __webpack_public_path__ + "img/gh-305em-03-12.prt.a23a77af.jpg";